module.exports = __webpack_public_path__ + "img/telescope.dc5dec9a.svg";